import { StyledStickyTabs } from "./styles";
import type { SerpOverlayPageTabItem } from "./types";

type Props = {
    items: SerpOverlayPageTabItem[];
    selectedValue: string;
    onItemClick: (pageNumber: number) => void;
};

export const SerpOverlayPageSwitcher = ({ items, selectedValue, onItemClick }: Props) => {
    const isSinglePage = items.length <= 1;
    return (
        <StyledStickyTabs
            activeTab={selectedValue}
            onTabClick={(tabId) => {
                if (isSinglePage) {
                    return;
                }
                const pageNumber = items.find((item) => item.id === tabId)?.pageNumber;
                if (pageNumber) {
                    onItemClick(pageNumber);
                }
            }}
            items={items.map(({ id, label }) => ({
                id,
                title: label,
            }))}
        />
    );
};
